import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../../theme-layouts/shared-components/LanguageSwitcher';

function Error500Page() {
	const { t } = useTranslation('errorPages');

	return (
		<div className="flex flex-col flex-1 items-center justify-center p-16">
			<div className="max-w-512 text-center">
				<motion.div
					initial={{ opacity: 0, scale: 0.6 }}
					animate={{ opacity: 1, scale: 1, transition: { delay: 0.1 } }}
				>
					<Typography variant="h1" color="inherit" className="font-medium mb-16">
						{t('ERROR500')}
					</Typography>
				</motion.div>

				<motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0, transition: { delay: 0.2 } }}>
					<Typography variant="h5" color="textSecondary" className="mb-16 font-normal">
						{t('ERROR500TEXT')}
					</Typography>
				</motion.div>

				<motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0, transition: { delay: 0.3 } }}>
					<Typography variant="subtitle1" color="textSecondary" className="mb-16">
						{t('ERROR500SUBTEXT')}
					</Typography>

					<div className="items-center w-full h-56 mb-48">
						<LanguageSwitcher />
					</div>
				</motion.div>

				<Link className="text-18 font-medium" to="/reportproblem">
					{t('REPORTPROBLEM')}
				</Link>
			</div>
		</div>
	);
}

export default Error500Page;
